var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3952 24.3952C28.8862 19.9041 28.8862 12.6227 24.3952 8.1317C19.9042 3.64067 12.6228 3.64067 8.13173 8.1317C3.6407 12.6227 3.6407 19.9041 8.13173 24.3952C12.6228 28.8862 19.9042 28.8862 24.3952 24.3952Z",
    fill: "#DA293E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6443 19.1917C15.417 19.1917 15.2226 18.9978 15.1831 18.7311L14.0209 10.8922C13.8748 9.905 14.5126 9 15.3543 9H15.9337C16.7754 9 17.4131 9.905 17.267 10.8922L16.1048 18.7311C16.0659 18.9978 15.8715 19.1917 15.6443 19.1917Z",
    fill: "#E6E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7076 22.1407C16.7076 21.5552 16.2298 21.0774 15.6443 21.0774C15.0587 21.0774 14.5809 21.5552 14.5809 22.1407C14.5809 22.7263 15.0587 23.2041 15.6443 23.2041C16.2298 23.2041 16.7076 22.7268 16.7076 22.1407Z",
    fill: "#E6E9ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/IconError.68e1231d4267aa314b410de517a7da19.svg";
export { ForwardRef as ReactComponent };